// extracted by mini-css-extract-plugin
export default {"input":"_31-LZ","wrapper":"zQ0rM","radio":"zjn6K","label":"X4nci"};